const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

const controller = '/v1/chronique';

export const ScheduleGroupCommand: any = {
    deleteScheduleGroup: Backofficebff + controller + '/delete-schedule-group',
    createScheduleGroup: Backofficebff + controller + '/create-schedule-group',
    updateScheduleGroup: Backofficebff + controller + '/update-schedule-group',
    createGroupUser: Backofficebff + controller + '/create-schedule-group-user',
    deleteGroupUser: Backofficebff + controller + '/delete-schedule-group-user',
};
